import jQuery from 'jquery';

jQuery(function ($) {
    'use strict';

    const $openers = $('.accordion .opener');

    $openers.parent().addClass('closed');

    $openers.on('click', function (e) {
        e.preventDefault();
        const expanded = $(this).attr('aria-expanded');
        $(this).attr('aria-expanded', expanded === 'true' ? 'false' : 'true');
        $(this).parent().toggleClass('closed');
    });
});